import moment from "moment";

export const formattedDatetime = (date: string) => {
  return moment(date, "ddd MMM DD HH:mm:ss z YYYY").format("MMM Do, YYYY, hh:mm a");
};
